import { render } from "./PatientAccountability.vue?vue&type=template&id=f71ade50&scoped=true"
import script from "./PatientAccountability.vue?vue&type=script&lang=js"
export * from "./PatientAccountability.vue?vue&type=script&lang=js"

import "./PatientAccountability.vue?vue&type=style&index=0&id=f71ade50&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f71ade50"]])

export default __exports__